/**
 * Call It In Dashboard - AppBar Component
 * Description: Custom top navigation bar for internal courier dashboard.
 * Author: Shaun Matthews
 * Company: Call It In LLC
 * Date: 2025
 * 
 * This file is part of the proprietary Call It In software suite.
 * All rights reserved. Unauthorized use or distribution is strictly prohibited.
 */


const link = {
  defaultProps: {
    underline: "none",
    color: "inherit",
  },
};

export default link;
